import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-[#222] bg-[#050505] mt-12" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-[10px] font-mono-data text-[#555] uppercase tracking-wider">
        <div className="max-w-3xl leading-relaxed">
          <span className="text-[#8a8a8e]">Not financial advice.</span>{" "}
          For educational & informational purposes only. Trading options carries substantial risk of loss.
          Past performance does not guarantee future results.
        </div>
        <div className="flex gap-4 shrink-0">
          <Link to="/disclaimer" data-testid="footer-disclaimer" className="hover:text-white">DISCLAIMER</Link>
          <Link to="/terms" data-testid="footer-terms" className="hover:text-white">TERMS</Link>
          <span className="text-[#333]">© PIRATETRADER</span>
        </div>
      </div>
    </footer>
  );
}
